module.exports = __webpack_public_path__ + "img/bottomLogo.17538552.png";